import { UsageAnalytics } from '4ff-lib-foundation/lib/AppFrame/publicAPI/services';

export const getSolutionById = (solutions, id) => (
  solutions.find(solution => solution.id === id)
);

export const getModuleById = (solution, id) => (
  solution && solution.children.find(module => module.id === id)
);

export const findPath = (node, value) => {
  const path = [];

  const getPath = (n, v) => {
    if (n.id === v) {
      path.push(n);
      return;
    }

    if (n.children?.length > 0) {
      n.children.forEach((child) => {
        if (path.length < 1) {
          getPath(child, v);
        }
      });
    } else if (n.children?.length === 0) {
      path.push(n);
    }

    if (path.length > 0) {
      path.push(n);
    }
  };

  getPath(node, value);

  return path;
};

export const trackEvent = (module, type, name, category, details) => {
  UsageAnalytics.trackEvent(module, type, name, category, details);
  UsageAnalytics.trackHeapEvent(name, { type, ...details });
};

export const getSectionItems = (section = {}) => section
  ?.children?.filter(item => !item.meta || (item.meta && !item.meta.lpbDashboardHide)) ?? null;

export const isNodeVisible = child => !child.meta || (child.meta && !child.meta.lpbDashboardHide);
